import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboard-customer-project--hd" }
const _hoisted_2 = { class: "d_p_n" }
const _hoisted_3 = { class: "d_p_l" }
const _hoisted_4 = { class: "d_a_l" }
const _hoisted_5 = { class: "dashboard-customer-project--content" }
const _hoisted_6 = { class: "d_p_n" }
const _hoisted_7 = { class: "d_p_b" }
const _hoisted_8 = { class: "d_p_img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "d_p_name" }
const _hoisted_11 = { class: "d_p_l" }
const _hoisted_12 = { class: "p_l_b" }
const _hoisted_13 = { class: "p_l_img" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "p_l_name" }
const _hoisted_16 = { class: "d_a_l" }
const _hoisted_17 = {
  key: 0,
  class: "v1-load-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.constants.PROJECTS_TEXT), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.constants.PROJECTS_LEAD_TEXT), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.constants.ACTION_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedProjects, (project) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "customer-project--list",
          key: project.id
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: project.avatarUrls['48x48'],
                  alt: ""
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  id: "detailLink",
                  to: `/employee/project-detail/${project.key}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(project.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: project.lead.avatarUrls['48x48'],
                  alt: ""
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, _toDisplayString(project.lead.displayName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: `/employee/project-detail/${project.key}`,
                  id: "detailLink"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.constants.DETAIL_LINK), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ]))
      }), 128)),
      (_ctx.showLoadMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "v1-button-outline",
              id: "projectLoadMoreBtn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMoreProjects && _ctx.loadMoreProjects(...args)))
            }, _toDisplayString(_ctx.constants.LOAD_MORE_BUTTON), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}